import { Box, Input, Icon, SidebarGroup } from "~/components/UI";
import SideBarFilterContainer from "~/components/SideBarFilter/SideBarFilterContainer";
import IncludeFieldGroup from "~/components/SideBarFilter/IncludeFieldGroup";
import SelectEnum from "~/components/SideBarFilter/SelectEnum";
import { WALLET_TYPE, WALLET_TYPE_I18n } from "~/api/wallets/enums";
import { useTranslation } from "react-i18next";

interface FilterProps {
  onChangeFilter: (data: WalletsApi.GetWalletsQuery) => void | Promise<void>;
}

const Filter = ({ onChangeFilter }: FilterProps) => {
  const { t } = useTranslation();

  return (
    <SideBarFilterContainer onChangeFilter={onChangeFilter}>
      <Box pb={6}>
        <Input
          name="search"
          startAdornment={<Icon name="Lens" />}
          placeholder={t("text.searchByID")}
          fullWidth
          formikControll
        />
        <SidebarGroup
          label={t("label.walletType")}
          collapsed
          defaultOpen={true}
        >
          <SelectEnum
            fieldName="walletType"
            enumValue={WALLET_TYPE}
            enumI18n={WALLET_TYPE_I18n}
          />
        </SidebarGroup>
        <IncludeFieldGroup label={t("table.enabled")} fieldName="enabled" />
        <IncludeFieldGroup
          label={t("title.openedIcidents")}
          fieldName="hasOpenedIncidents"
        />
      </Box>
    </SideBarFilterContainer>
  );
};

export default Filter;
